export class URITemplates
{
    public readonly getOrganizationDetails:string='/dashboard/getOrganizationDetails'
    public readonly getNetworkZipCodes:string='/dashboard/getNetworkZipCodes'
    public readonly getLatlons:string='/dashboard/getLatlons';
    public readonly getProviders:string='/dashboard/getProviders';
    public readonly getFacility:string='/dashboard/getFacilities';
    public readonly SaveContactUsDetails:string='/dashboard/SaveContactUsDetails';
    public readonly getfaq:string='/dashboard/getfaq';
    public readonly getPharmacy:string='/dashboard/getPharmacies';
    public readonly SavePrintRequest:string='/dashboard/SavePrintRequest';    
    public readonly GetCategories:string='/dashboard/GetCategories';    
    public readonly getAllStates:string='/dashboard/getAllStates';
    public readonly sendemails:string='/dashboard/sendemails';    
    public readonly GetNotificationsContent:string='/dashboard/GetNotificationsContent';    
    public readonly getDefaultContent:string='/dashboard/getDefaultContent';
    public readonly getProductionDateTime:string='/dashboard/getProductionDateTime';
    
}